import React, { Component } from 'react'
import { Table } from 'reactstrap'
import { ItemRows } from './'

class ItemsTable extends Component {
  render() {
    const { items, activeItemId, handleClickItem, filter } = this.props
    return (
      <div  style={{height: '1500px', overflow: 'scroll'}}>
        <Table responsive >
          <thead>
          <tr>
            <th>Code</th>
            <th>Preview</th>
          </tr>
          </thead>
          <ItemRows 
            items={items}
            activeItemId={activeItemId}
            handleClickItem={handleClickItem}
            filter={filter}
          />
        </Table>
      </div>
    )
  }
}

export default ItemsTable


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ItemsTable.js